import styled from "styled-components";

export const Container = styled.div`
  background: #f3f6ff;
  padding-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;

  div > div {
    display: flex;
  }

  div > div > img:first-child {
    margin-right: 30px;
  }

  h2,
  p {
    text-align: start;
    margin: 0;
    padding: 0;
  }

  h2 {
    font-family: Averta PE;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.15px;
    color: #1b2852;
  }

  p {
    font-family: Averta PE;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.15px;
    color: #69769b;
    margin: 10px 0 16px 0;
  }

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Divider = styled.div`
  margin-left: 24px;
  margin-right: 42px;
  border: 1px solid #a3afd1;
  width: 0px;
  height: 124px;
`;
